import { request } from "utils/request";
import { AxiosPromise } from "axios";
import { SaleStatsPeriod, SaleStatsSection } from "types/saleStats";

export const saleStatsApi = {
  summary: (params: { staffId?: number; period: SaleStatsPeriod; date: string }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/sale-stats",
      params,
    }),

  list: (params: {
    section: SaleStatsSection;
    staffId?: number;
    period: SaleStatsPeriod;
    date: string;
    page: number;
    limit: number;
  }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/sale-stats/list",
      params,
    }),
};
